import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import ProfilePopupForm from '../Forms/ProfilePopupForm/ProfilePopupForm';
import {CloseIcon} from '../Icons/Icons';
import classnames from 'classnames';

import "./profilepopup.scss";
import {setMyAccountPopupState} from '../../redux/actions/general';
import TextTranslate from '../TextTranslate/TextTranslate';

function ProfilePopup({user, ...props}) {
    const [success, setSuccess] = useState('');
    const [errors, setErrors] = useState(null);

    if (!user) {
        return <></>
    }

    useEffect(()=>{
        setForm({
            first_name: user.first_name,
            last_name: user.last_name,
            email: user.email,
            phone: user.phone,
        })
    }, [user]);

    const [form, setForm] = useState({
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        phone: user.phone,
    });

    const handleClosePopup = () => {
        props.dispatch(setMyAccountPopupState(false))
    }

    return (
        <div
            className={classnames(
                ["profile-popup-wrapper",
                    {
                        open: props.isShown
                    }
                ])}
        >
            <div className="profile-popup">
                <div className="popup-close">
                    <CloseIcon onClick={handleClosePopup}/>
                </div>
                <div>
                    <h2><TextTranslate name="user-my-profile" fallback="My Profile" textOnly/></h2>
                </div>
                <div className="row no-gutters flex-1">
                    <div className="col-12 d-flex flex-column">
                        <h4><TextTranslate name="user-account-details" fallback="Account Details" textOnly/></h4>

                        {success && (
                            <div className="alert alert-success" role="alert">
                                {success}
                            </div>
                        )}

                        {errors?.message && (
                            <div className="alert alert-danger" role="alert">
                                {errors?.message}
                            </div>
                        )}

                        <ProfilePopupForm
                            values={form}
                            errors={errors?.errors}
                            setErrors={setErrors}
                            setSuccess={setSuccess}
                        />

                    </div>
                </div>
            </div>

            <div className="dimmer" onClick={handleClosePopup}></div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    isShown: state.general.myProfileOpen,
});

export default connect(mapStateToProps)(ProfilePopup);
